// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-analytics-container {
  padding: 24px;
  background: #f0f2f5;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 24px;
  background: white;
  padding: 24px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #1890ff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
}

.page-subtitle {
  margin: 8px 0 0 0;
  font-size: 14px;
  color: #8c8c8c;
}

.table-card {
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.table-card .ant-table-thead > tr > th {
  background: #fafafa;
  font-weight: 600;
  color: #262626;
  border-bottom: 2px solid #e8e8e8;
}

.table-card .ant-table-tbody > tr:hover > td {
  background: #f5f5f5;
}

.table-card .ant-table-tbody > tr > td {
  padding: 16px;
}

/* Fix for vertical scrollbar issue in table cells */

.table-card .ant-table-cell {
  overflow: visible !important;
  overflow-x: visible !important;
  overflow-y: visible !important;
}

/* Ensure text wraps properly in center name column */

.table-card .ant-table-cell strong {
  word-break: break-word;
  white-space: normal;
  line-height: 1.5;
}

/* Responsive adjustments */

@media (max-width: 768px) {
  .center-analytics-container {
    padding: 16px;
  }

  .page-header {
    padding: 16px;
  }

  .page-title {
    font-size: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./pages/CenterAnalytics/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,oDAAoD;;AACpD;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,qDAAqD;;AACrD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".center-analytics-container {\r\n  padding: 24px;\r\n  background: #f0f2f5;\r\n  min-height: 100vh;\r\n}\r\n\r\n.page-header {\r\n  margin-bottom: 24px;\r\n  background: white;\r\n  padding: 24px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.page-title {\r\n  margin: 0;\r\n  font-size: 28px;\r\n  font-weight: 600;\r\n  color: #1890ff;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.page-subtitle {\r\n  margin: 8px 0 0 0;\r\n  font-size: 14px;\r\n  color: #8c8c8c;\r\n}\r\n\r\n.table-card {\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.table-card .ant-table-thead > tr > th {\r\n  background: #fafafa;\r\n  font-weight: 600;\r\n  color: #262626;\r\n  border-bottom: 2px solid #e8e8e8;\r\n}\r\n\r\n.table-card .ant-table-tbody > tr:hover > td {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.table-card .ant-table-tbody > tr > td {\r\n  padding: 16px;\r\n}\r\n\r\n/* Fix for vertical scrollbar issue in table cells */\r\n.table-card .ant-table-cell {\r\n  overflow: visible !important;\r\n  overflow-x: visible !important;\r\n  overflow-y: visible !important;\r\n}\r\n\r\n/* Ensure text wraps properly in center name column */\r\n.table-card .ant-table-cell strong {\r\n  word-break: break-word;\r\n  white-space: normal;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .center-analytics-container {\r\n    padding: 16px;\r\n  }\r\n\r\n  .page-header {\r\n    padding: 16px;\r\n  }\r\n\r\n  .page-title {\r\n    font-size: 22px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
